import React from 'react'

const PHGInPictures = () => {
    
    return(
        <div className="container-fluid feature bg-light py-5">
        <div className="container py-5">
            <div className="text-center mx-auto pb-5 wow fadeInUp" data-wow-delay="0.2s" style={{maxWidth: '800px'}}>
                <h4 className="text-uppercase text-primary">Our Gallery</h4>
                <h1 className="display-3 text-capitalize mb-3">PHG In Pictures</h1>
            </div>
            <div className="row g-4">
                <div className=" col-md-6 col-lg-6 col-xl-3 wow fadeInUp" data-wow-delay="0.2s">
                    <div className="feature-item">
                             <img src="img/phg-in-pictures/uip-1.jpg" alt='uip-1' width="100%" />                    </div>
                </div>
                <div className="col-md-6 col-lg-6 col-xl-3 wow fadeInUp" data-wow-delay="0.4s">
                    <div className="feature-item">
                        <img src="img/phg-in-pictures/uip-3.jpg" alt='uip-3' width="100%" />
                    </div>
                </div>
                <div className="col-md-6 col-lg-6 col-xl-3 wow fadeInUp" data-wow-delay="0.6s">
                    <div className="feature-item">
                        <img src="img/phg-in-pictures/uip-2.jpg" alt='uip-2' width="100%" />
                    </div>
                </div>
                <div className="col-md-6 col-lg-6 col-xl-3 wow fadeInUp" data-wow-delay="0.8s">
                    <div className="feature-item">
                        <img src="img/phg-in-pictures/uip-4.jpg" alt='uip-4' width="100%" />
                    </div>
                </div>
                <div className="col-md-6 col-lg-6 col-xl-3 wow fadeInUp" data-wow-delay="1.0s">
                    <div className="feature-item">
                        <img src="img/phg-in-pictures/uip-5.jpg" alt='uip-5' width="100%" />
                    </div>
                </div>
                <div className="col-md-6 col-lg-6 col-xl-3 wow fadeInUp" data-wow-delay="1.2s">
                    <div className="feature-item">
                        <img src="img/phg-in-pictures/uip-6.jpg" height={'202px'} alt='uip-6' width="100%" />
                    </div>
                </div>
                <div className="col-md-6 col-lg-6 col-xl-3 wow fadeInUp" data-wow-delay="1.4s">
                    <div className="feature-item">
                        <img src="img/phg-in-pictures/uip-7.jpg" alt='uip-7' width="100%" />
                    </div>
                </div>
                <div className="col-md-6 col-lg-6 col-xl-3 wow fadeInUp" data-wow-delay="1.4s">
                    <div className="feature-item">
                        <img src="img/phg-in-pictures/uip-8.jpg" alt='uip-8' height={'205px'} width="100%" />
                    </div>
                </div>
                <div className="col-md-6 col-lg-6 col-xl-3 wow fadeInUp" data-wow-delay="1.4s">
                    <div className="feature-item">
                        <img src="img/phg-in-pictures/uip-9.jpg" alt='uip-9' height={'205px'} width="100%" />
                    </div>
                </div>
                <div className="col-md-6 col-lg-6 col-xl-3 wow fadeInUp" data-wow-delay="1.4s">
                    <div className="feature-item">
                        <img src="img/phg-in-pictures/uip-10.jpg" alt='uip-10' width="100%" />
                    </div>
                </div>
                <div className="col-md-6 col-lg-6 col-xl-3 wow fadeInUp" data-wow-delay="1.6s">
                    <div className="feature-item">
                        <img src="img/phg-in-pictures/uip-11.jpg" alt='uip-11' width="100%" />
                    </div>
                </div>
                <div className="col-md-6 col-lg-6 col-xl-3 wow fadeInUp" data-wow-delay="1.6s">
                    <div className="feature-item">
                        <img src="img/phg-in-pictures/uip-12.jpg" alt='uip-12' width="100%" />
                    </div>
                </div>

            </div>
        </div>
    </div>
    )
//   return (
//     <div  className="container-fluid feature bg-light py-5">
//         <div className="text-center mx-auto pb-5 wow fadeInUp" data-wow-delay="0.2s" style={{maxWidth: '800px'}}>
//                 <h4 className="text-uppercase text-primary">Our Gallery</h4>
//                 <h1 className="display-3 text-capitalize mb-3">PHG In Pictures</h1>
            
//         </div>
//         <div>
//             <div className='row'>
//             <img className='uip-image' src='img/phg-in-pictures/uip-1.jpg' alt='uip-1'></img>
//             <img className='uip-image' src='img/phg-in-pictures/uip-2.jpg' alt='uip-2'></img>
//             <img className='uip-image' src='img/phg-in-pictures/uip-3.jpg' alt='uip-3'></img>
//             <img className='uip-image' src='img/phg-in-pictures/uip-4.jpg' alt='uip-4'></img>
//             </div>
//             <img className='uip-image' src='img/phg-in-pictures/uip-5.jpg' alt='uip-5'></img>
//             <img className='uip-image' src='img/phg-in-pictures/uip-6.jpg' alt='uip-6'></img>
//             <img className='uip-image' src='img/phg-in-pictures/uip-7.jpg' alt='uip-7'></img>
//             <img className='uip-image' src='img/phg-in-pictures/uip-8.jpg' alt='uip-8'></img>
//             <img className='uip-image' src='img/phg-in-pictures/uip-9.jpg' alt='uip-9'></img>
//             <img className='uip-image' src='img/phg-in-pictures/uip-10.jpg' alt='uip-10'></img>
//         </div>
//     </div>

    

//   )
}

export default PHGInPictures